/**
 * ViewMenu
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';

class ViewMenu {

	private $parent: any;

	private _id: string;

	constructor( $parent: any, isNotice: boolean ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );

		if ( isNotice ) {
			this.remove();
		}

		this.addEvent();
	}

	private remove() {
		jQuery( `#${this._id} .ncCommunityMoreButton` ).hide();
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', ( evt ) => {
			const container = jQuery( `#${this._id} .ncCommunityMoreButton` );
			if (!container.is( evt.target ) && container.has( evt.target ).length === 0 ) {
				container.removeClass( 'is-active' );
			}
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommunityMoreButton`, ( evt ) => {
			evt.preventDefault();
			const _$target = jQuery( evt.currentTarget );
			( _$target.hasClass( 'is-active' ) ) ?
				_$target.removeClass( 'is-active' ) :
				_$target.addClass( 'is-active' );
		}).trigger( 'click' );
	}

}

export default ViewMenu;
